import * as ActionTypes from './actionTypes';

export function selectWidget(widget) {
  return {
    type: ActionTypes.MAP_SELECT_WIDGET,
    payload: {
      widget,
    },
  };
}

export function addPortalRequest(widget, projectId) {
  return {
    type: ActionTypes.MAP_ADD_PORTAL_REQUEST,
    payload: {
      widget,
      projectId,
    },
  };
}

export function portalAdded(widget, key) {
  return {
    type: ActionTypes.MAP_ADD_PORTAL_RESPONSE,
    payload: {
      widget,
      key,
    },
  };
}

export function updateWidgetRequest(widget, projectId) {
  return {
    type: ActionTypes.MAP_UPDATE_WIDGET_REQUEST,
    payload: {
      widget,
      projectId,
    },
  };
}

export function updateWidgetResponse(widget) {
  return {
    type: ActionTypes.MAP_UPDATE_WIDGET_RESPONSE,
    payload: {
      widget,
    },
  };
}

export function removeWidget(widgetId, projectId) {
  return {
    type: ActionTypes.MAP_REMOVE_WIDGET,
    payload: {
      widgetId,
      projectId,
    },
  };
}

export function removeWidgetLocally(widgetId, projectId) {
  return {
    type: ActionTypes.MAP_REMOVE_WIDGET_LOCAL,
    payload: {
      widgetId,
      projectId,
    },
  };
}

export function removeConnectors(connectors, projectId) {
  return {
    type: ActionTypes.MAP_REMOVE_CONNECTOR,
    payload: {
      connectors,
      projectId,
    },
  };
}

export function removeConnector(connector, projectId) {
  return {
    type: ActionTypes.MAP_REMOVE_CONNECTOR,
    payload: {
      connectors: [connector],
      projectId,
    },
  };
}

export function removeConnectorLocally(connectorId, projectId) {
  return {
    type: ActionTypes.MAP_REMOVE_CONNECTOR_LOCAL,
    payload: {
      connectors: [connectorId],
      projectId,
    },
  };
}

export function widgetRemoved(widgetId) {
  return {
    type: ActionTypes.MAP_REMOVE_WIDGET_SUCCESS,
    payload: {
      widgetId,
    },
  };
}

export function addConnectorRequest(connector, projectId) {
  return {
    type: ActionTypes.MAP_ADD_CONNECTOR_REQUEST,
    payload: {
      connector,
      projectId,
    },
  };
}

export function connectorAdded(connector, key) {
  return {
    type: ActionTypes.MAP_ADD_CONNECTOR_RESPONSE,
    payload: {
      connector,
      key,
    },
  };
}

export function updateConnector(connector) {
  return {
    type: ActionTypes.MAP_UPDATE_CONNECTOR,
    payload: {
      connector,
    },
  };
}

export function updateMapRequest(widgets, connectors, projectId) {
  return {
    type: ActionTypes.MAP_UPDATE_REQUEST,
    payload: {
      widgets,
      connectors,
      projectId,
    },
  };
}

export function updateMapResponse(widgets, connectors) {
  return {
    type: ActionTypes.MAP_UPDATE_RESPONSE,
    payload: {
      widgets,
      connectors,
    },
  };
}

export function loadMap(widgets, connectors, selectedWidget) {
  return {
    type: ActionTypes.MAP_LOAD,
    payload: {
      widgets,
      connectors,
      selectedWidget,
    },
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/map.js